
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceSwellTrue as ObiForceSwellTrueElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-swell-true.js';
 
 
 

 
 export const ObiForceSwellTrue = createComponent({
   react: React,
   tagName: 'obi-force-swell-true',
   elementClass: ObiForceSwellTrueElement,
   events: {
     
   }
  });
 
 